<div id="offer-top" *ngIf="(this.user.roles.admin || this.user.roles.GlobalCompEditor || this.user.roles.editor)">

    <div @anim class="current-date row-param-holder">
        <h3>תאריך: </h3>
        <span class="minutes">{{this.date | date:'HH:mm'}}</span>
        <span>{{ this.date | date:'dd'}}.{{this.date | date:'MM'}}.{{this.date | date:'yy'}} </span>
    </div>

    <div class="row-param-holder">
        <h3>משווק: </h3>
        <div>{{ user.displayName}}</div>
    </div>

    <!-- <div>{{ user.email}}</div>
    <div>{{ user.phone }}</div> -->
    <!-- <div class="" *ngIf="auth.currentUserSubject | async as user">
        <div class="user-details-holder">
            <div class="title-holder">
                <h3 >{{ user.displayName }}</h3>
                <div>{{ user.email }}</div>
            </div>
    </div> -->



    <div class="user-form">
        <h3>פרטי לקוח</h3>
        <app-client-form [(formData)]="formData" (submitForm)="onSubmit($event)"></app-client-form>
        <!-- <p>Parent Value: {{ formData | json }}</p> -->
        <!-- <app-client-form [firstName]="firstName"></app-client-form> -->
    </div>


    <div class="add-unit-holder">
        <!-- <h2>Property Calculator</h2> -->
        <form>
            <div class="amount-adding-holder">
                <!-- <div class="type-section">
                    <div class="background-light" (click)="closeSearch()" [class.active]="showSearchResults"></div>
                    <h3 for="unitNumber">מספר יחידה:</h3>
                    <app-autocomplite [units]="this.units" [parentShowResoults]="showSearchResults"
                        (showSearchResults)="showSearchResultsF($event)"
                        (choisen)="choisenUnitNumber($event)"></app-autocomplite>
                </div> -->
                <div class="type-section">
                    <h3 for="officeLandCostPerSqM">עלות קרקע ליחידה:</h3>
                    <div class="background-light" (click)="closeSearch()" [class.active]="showSearchResults"></div>
                    <app-autocomplite [units]="this.units" [parentShowResoults]="showSearchResults"
                        (showSearchResults)="showSearchResultsF($event)"
                        (choisen)="choisenUnitNumber($event)"></app-autocomplite>
                    <div class="range-section">
                        <label>טווח אחוז הנחה</label>
                        <form>
                            <div
                                *ngIf="(this.user.roles.admin || this.user.roles.GlobalCompEditor) && officeLandCostPerSqMScope">
                                <input type="number" id="discountPercentageScope.discountPercentageFrom"
                                    [(ngModel)]="discountPercentageScope.discountPercentageFrom"
                                    name="discountPercentageFrom" /> -
                                <input type="number" id="discountPercentageScope.discountPercentageUntill"
                                    [(ngModel)]="discountPercentageScope.discountPercentageUntill"
                                    name="discountPercentageUntill" />
                                <button type="button" (click)="discountPercentageScopeF()" mat-stroked-button>
                                    שמור</button>
                            </div>
                        </form>
                    </div>
                    <!-- <label for="officeLandCostPerSqM">אחוז הנחה:</label>
                    <input type="number" id="officeLandCostPerSqM" [(ngModel)]="officeLandCostPerSqM"
                        name="officeLandCostPerSqM" /> -->
                    <label for="discountPercentage">אחוז הנחה:</label>
                    <input type="number" id="discountPercentage" [(ngModel)]="discountPercentage"
                        name="discountPercentage" />

                </div>

                <div class="type-section">
                    <div>
                        <h3 for="parkingSpaceCost">עלות חניה:</h3>
                        <div class="range-section">
                            <form>
                                <h5> טווח מחיר של חניה</h5>
                                <div
                                    *ngIf="(this.user.roles.admin || this.user.roles.GlobalCompEditor) && parkingSpaceCostScope">
                                    <input type="number" id="parkingSpaceCostScope.parkingSpaceCostFrom"
                                        [(ngModel)]="parkingSpaceCostScope.parkingSpaceCostFrom"
                                        name="parkingSpaceCostFrom" />
                                    -
                                    <input type="number" id="parkingSpaceCostScope.parkingSpaceCostUntill"
                                        [(ngModel)]="parkingSpaceCostScope.parkingSpaceCostUntill"
                                        name="parkingSpaceCostUntill" />
                                    <button type="button" (click)="parkingSpaceCostScopeF()"
                                        mat-stroked-button>שמור</button>
                                </div>
                            </form>
                        </div>
                        <label for="parkingSpaceCost">עלות חניה</label>
                        <input type="number" id="parkingSpaceCost" [(ngModel)]="parkingSpaceCost"
                            name="parkingSpaceCost" />
                    </div>
                    <div>
                        <label for="numberOfParkingSpaces">מספר חניות:</label>
                        <input type="number" id="numberOfParkingSpaces" [(ngModel)]="numberOfParkingSpaces"
                            name="numberOfParkingSpaces" />
                    </div>
                </div>

                <!-- <div class="type-section">
                    <div>
                        <h3 for="storageSpaceCost">עלות מחסן:</h3>
                        <div class="range-section">
                            <form>
                                <h5>טווח מחיר של מחסן</h5>
                                <div
                                    *ngIf="(this.user.roles.admin || this.user.roles.GlobalCompEditor) && storageSpaceCostScope">
                                    <input type="number" id="storageSpaceCostScope.storageSpaceCostFrom"
                                        [(ngModel)]="storageSpaceCostScope.storageSpaceCostFrom"
                                        name="storageSpaceCostFrom" />
                                    -
                                    <input type="number" id="storageSpaceCostScope.storageSpaceCostUntill"
                                        [(ngModel)]="storageSpaceCostScope.storageSpaceCostUntill"
                                        name="storageSpaceCostUntill" />
                                    <button type="button" (click)="storageSpaceCostScopeF()"
                                        mat-stroked-button>שמור</button>
                                </div>
                            </form>
                        </div>
                        <label for="storageSpaceCost">עלות מחסן</label>
                        <input type="number" id="storageSpaceCost" [(ngModel)]="storageSpaceCost"
                            name="storageSpaceCost" />
                    </div>
                    <div>
                        <label for="numberOfStoragesSpaces">מספר מחסנים:</label>
                        <input type="number" id="numberOfStoragesSpaces" [(ngModel)]="numberOfStoragesSpaces"
                            name="numberOfStoragesSpaces" />
                    </div>
                </div> -->
            </div>






            <button class="btn" type="button" (click)="addProperty()">הוסף נכס</button>
        </form>
    </div>
    <div id="offer">
        <div class="page">
            <h1 class="page-title">פרטי נכסים</h1>
            <div class="table-holder" *ngIf="calculatedProperties.length > 0">
                <!-- <h3>פרטי נכסים</h3> -->
                <table>
                    <thead>
                        <tr>
                            <th>מספר יחידה</th>
                            <th>מחיר</th>
                            <th>שטח יחידה כולל ממ''ד(מ"ר)</th>
                            <!-- <th>שטח ממ"ק (מ"ר)</th> -->
                            <th>שטח מחסן (מ"ר)</th>
                            <th>שטח מרפסת (מ"ר)</th>
                            <th>עלות בניה</th>
                            <!-- <th>עלות כוללת</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let property of calculatedProperties">
                            <td>{{property.unitNumber}}</td>
                            <td>{{property.defaultPrice  | currency: 'ILS':'symbol':'1.0-0'}}</td>
                            <td>{{property.officeArea | RoundUpPipe}}</td>
                            <!-- <td>{{property.shelterArea | RoundUpPipe}}</td> -->
                            <!-- <td>{{property.numberOfStoragesSpaces | RoundUpPipe}}</td> -->
                            <td>{{property.storageArea | RoundUpPipe}}</td>
                            <td>{{property.balconiesSize | RoundUpPipe}}</td>
                            <td>{{property.constructionCost | currency: 'ILS':'symbol':'1.0-0'}}</td>
                            <!-- <td>{{property.numberOfParkingSpaces}} -----------------------------Parking</td>
                        <td>{{property.numberOfStoragesSpaces}} -----------------------------Storage</td> -->
                            <!-- <td>{{property.totalCost | currency:'ILS'}}</td> -->
                            <td> <button type="button" class="btn btn-primary" *ngIf="!showPreview"
                                    (click)="removeProperty(property)">מחק</button></td>
                            <!-- <td><button type="button" (click)="removeProperty( {{ property.unitNumber }})">delete</button></td> -->
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="table-holder" *ngIf="calculatedProperties.length > 0">
                <h3>סיכום נתוני נכסים</h3>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th><span class="highlight-meter">מ''ר</span> / <span class="highlight-quantity">כמות</span></th>
                            <th></th>
                            <th>מחיר כולל</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th class="column-title"> יחידה </th>
                            <td>{{totalArea | RoundUpPipe}}</td>
                            <td> </td>
                            <td>{{unitTotalPrice | currency: 'ILS':'symbol':'1.0-0' }}</td>
                        </tr>
                        <!-- New row for Attached Common Area Price -->
                        <!-- <tr>
                            <th class="column-title">מחיר ממ"ק מוצמד</th>
                            <td>{{shelterArea}}</td>
                            <td>{{attachedshelterAreaPricePerSqM | currency: 'ILS':'symbol':'1.0-0'}}</td>
                            <td>{{shelterTotalCost | currency: 'ILS':'symbol':'1.0-0'}}</td>
                        </tr>  -->
                        <tr>
                            <th class="column-title"> מרפסת </th>
                            <td>{{balconiesSize | RoundUpPipe}}</td>
                            <!-- <td>{{attachedBalconyAreaPricePerSqM | currency: 'ILS':'symbol':'1.0-0'}}</td>
                            <td>{{balconyTotalCost | currency: 'ILS':'symbol':'1.0-0'}}</td> -->
                        </tr>
                        <tr>
                            <th class="column-title"> מחסן </th>
                            <td>{{storageArea | number}}</td>
                            <!-- <td>{{storageSpaceCost | currency: 'ILS':'symbol':'1.0-0'}}</td>
                            <td>{{storageSpaceTotalCost | currency: 'ILS':'symbol':'1.0-0'}}</td> -->
                        </tr>
                        <tr>
                            <th class="column-title"> חניה </th>
                            <td><span *ngIf="numberOfParkingSpaces" class="highlight-quantity">
                                {{numberOfParkingSpaces | number}}
                            </span>
                            </td>
                            <!-- <td>{{parkingSpaceCost | currency: 'ILS':'symbol':'1.0-0'}}</td> -->
                            <td></td>
                            <td>{{parkingTotalCost | currency: 'ILS':'symbol':'1.0-0'}}</td>
                        </tr>
                        <tr>
                            <th class="column-title"> סה"כ מחיר כולל מע''מ</th>
                            <td></td>
                            <td></td>
                            <td>{{this.sumOfTotalCostsExcludeConstraction | currency: 'ILS':'symbol':'1.0-0'}}</td>
                        </tr>

                    </tbody>
                </table>
                <table class="commission">
                    <tbody>
                        <tr>
                            <td>
                                <h4> עמלת שיווק</h4>
                            </td>
                            <td>
                                <!-- {{ marketingCommissionPerSqM }} -->
                            </td>
                            <td>
                                {{ totalArea | RoundUpPipe}}
                            </td>
                            <td>
                                {{ marketingCommissionTotalCost | currency: 'ILS':'symbol':'1.0-0'}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h4> שכ"ט עורך דין - 1.5%</h4>
                            </td>
                            <td>
                            </td>
                            <td>
                            </td>
                            <td>
                                {{ this.lawyerFee | currency: 'ILS':'symbol':'1.0-0' }}
                            </td>
                        </tr>
                    </tbody>

                </table>

            </div>
        </div>
        <!-- 
        <div class="page insert-pages-after">
            <h1 class="page-title">סיכום נתוני נכסים</h1>
        <div class="table-holder" *ngIf="calculatedProperties.length > 0">
            <h3>סיכום נתוני נכסים</h3>
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th> מחיר ליחידה </th>
                        <th> מ"ר/כמות </th>
                        <th> סה"כ </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th class="column-title"> אומדן ע. בניה יחידה </th>
                        <td></td>
                        <td>

                            {{ totalArea + shelterArea + balconiesSize | RoundUpPipe}}
                        </td>
                        <td>{{ constructionTotalCost | currency: 'ILS':'symbol':'1.0-0'}}</td>
                    </tr>

                    <tr>
                        <th class="column-title"> אומדן ע. בניה חניה </th>
                        <td>{{parkingConstructionCost | currency: 'ILS':'symbol':'1.0-0'}}</td>
                        <td>{{numberOfParkingSpaces | number:'1.2-2'}}</td>
                        <td>{{parkingConstructionCost * numberOfParkingSpaces | currency: 'ILS':'symbol':'1.0-0'}}</td>
                    </tr>

                    <tr>
                        <th class="column-title"> אומדן יחידה כללי (בניה + קרקע) </th>
                        <td></td>
                        <td></td>
                        <td>{{unitTotalPrice + constructionTotalCost + balconyTotalCost + shelterTotalCost | currency: 'ILS':'symbol':'1.0-0'}}</td>
                    </tr>
                    <tr>
                        <th class="column-title"> אומדן יחידה כללי (בניה + קרקע + חניה) </th>
                        <td></td>
                        <td></td>
                        <td>{{this.totalCostIncludeAllExludeTaxes | currency: 'ILS':'symbol':'1.0-0'}}</td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div> -->
        <div class="page">
            <h1 class="page-title"> סה''כ יחידה + אומדנים </h1>
            <div class="table-holder particular-unit-properties" *ngFor="let prop of this.calculatedProperties"
                class="particular-unit">
                <h3>סה''כ יחידה + אומדנים </h3>
              <div class="titles-container"><h4>שם הנכס:</h4> <h4> {{ prop.unitNumber }}</h4></div>  
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>מחיר קרקע </th>
                            <th><span class="highlight-meter">מ''ר</span> / <span class="highlight-quantity">כמות</span></th>
                            <th>אומדן בנייה </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th class="column-title">יחידה</th>
                            <!-- <td>
                            {{ averagePricePerSqM * prop.officeArea + attachedshelterAreaPricePerSqM * prop.shelterArea + attachedBalconyAreaPricePerSqM * prop.balconiesSize | currency: 'ILS':'symbol':'1.0-0'}}
                        </td> -->
                            <td>
                                {{unitTotalPrice | currency: 'ILS':'symbol':'1.0-0'}}
                            </td>

                            <td>
                                {{ prop.officeArea | RoundUpPipe }}
                            </td>
                            <td>
                                {{ prop.constructionCost | currency: 'ILS':'symbol':'1.0-0' }}
                            </td>

                        </tr>

                        <tr>
                            <th class="column-title">מרפסת</th>
                            <td></td>
                            <td>
                                {{ prop.balconiesSize }}
                            </td>
                            <td>
                                <!-- {{attachedBalconyAreaPricePerSqM * prop.balconiesSize | currency: 'ILS':'symbol':'1.0-0'}} -->
                            </td>
                        </tr>

                        <tr>
                            <th class="column-title">מחסן</th>
                            <td>
                                <!-- {{storageSpaceCost * prop.numberOfStoragesSpaces | currency: 'ILS':'symbol':'1.0-0'}} -->
                            </td>
                            <td>
                                {{ prop.storageArea }}
                            </td>
                            <td>
                                <!-- {{constractionStorageCost * prop.numberOfStoragesSpaces | currency: 'ILS':'symbol':'1.0-0'}} -->
                            </td>
                        </tr>

                        <tr>
                            <th class="column-title"> חניה</th>
                            <td>
                                {{parkingSpaceCost * numberOfParkingSpaces | currency: 'ILS':'symbol':'1.0-0'}}
                            </td>
                            <td>
                                <!-- <span class="highlight-quantity">{{ prop.numberOfParkingSpaces }}</span>    -->
                                <span *ngIf="numberOfParkingSpaces" class="highlight-quantity">
                                    {{numberOfParkingSpaces | number}}
                                </span>
                            </td>
                            <td>
                                {{parkingConstructionCost * numberOfParkingSpaces | currency:
                                'ILS':'symbol':'1.0-0'}}
                            </td>
                        </tr>


                        <!-- <tr>
                        <th></th>
                        <th>מחיר קרקע מחסן</th>
                        <th>כמות מחסן</th>
                        <th>אומדן בנייה מחסן</th>
                    </tr> -->

              


                      

                        <!-- <tr>
                        <th class="column-title">ממ"ק</th>
                        <td>{{attachedBalconyAreaPricePerSqM | currency: 'ILS':'symbol':'1.0-0'}}</td>
                        <td>{{prop.shelterArea | RoundUpPipe}}</td>
                        <td>
                            {{attachedshelterAreaPricePerSqM * prop.shelterArea | currency: 'ILS':'symbol':'1.0-0'}}
                        </td>
                    </tr> -->


                        <!-- <tr>
                        <th></th>
                        <th> מחיר קרקע יחידה </th>
                        <th> כמה מטרים </th>
                        <th> אומדן בנייה יחידה </th>

                    </tr> -->




                        <tr>
                            <td></td>
                            <td></td>
                            <th>סה""כ מחיר קרקע</th>
                            <th>סה""כ אומדן יחידה כולל קרקע</th>
                        </tr>

                        <tr>
                            <td></td>
                            <td></td>
                            <td>
                                <span *ngIf="prop.officeArea">
                                    {{ this.sumOfTotalCostsExcludeConstraction | currency: 'ILS':'symbol':'1.0-0' }}

                                </span>
                                <!-- <span *ngIf="prop.storageArea">{{ averagePricePerSqM * prop.storageArea * 0.9 |
                                currency:'ILS'}}</span> -->
                            </td>
                            <td>
                                <span *ngIf="prop.officeArea">
                                    {{ this.totalCostIncludeAllExludeTaxes | currency: 'ILS':'symbol':'1.0-0' }}
                                </span>
                                <!-- <span *ngIf="prop.storageArea">{{ averagePricePerSqM * prop.storageArea * 0.9 +
                                prop.constructionCost | currency:'ILS'}}</span> -->
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div *ngIf="calculatedProperties.length > 0" class="small-table-holder">
                <div class="small-table">
                    <h3> <span>שכ"ט</span> </h3>
                    <table>
                        <!-- <tr>
                        <td>{{ this.lawyerFee | currency: 'ILS':'symbol':'1.0-0' }}</td>
                        <td>ללא מע"מ</td>
                    </tr> -->
                        <tr>
                            <td>{{ this.lawyerFee | currency: 'ILS':'symbol':'1.0-0' }} כולל מע''מ</td>
                            <!-- <td>כולל מע"מ</td> -->
                        </tr>
                    </table>
                </div>

                <div class="small-table">
                    <h3> <span>עמלת שיווק</span> </h3>
                    <table>
                        <tr>
                            <td>{{ marketingCommissionTotalCost | currency: 'ILS':'symbol':'1.0-0'}} כולל מע''מ</td>
                            <!-- <td>ללא מע"מ</td> -->
                        </tr>
                        <!-- <tr>
                        <td>{{ this.marketingCommissionTotalCost*1.17 | currency: 'ILS':'symbol':'1.0-0' }}</td>
                        <td>כולל מע"מ</td>
                    </tr> -->
                    </table>
                </div>

                <div class="small-table">
                    <h3> <span>סה''כ מחיר קרקע כולל חניות</span> </h3>
                    <table>
                        <tr>
                            <td>{{this.sumOfTotalCostsExcludeConstractionExcludeTaxes | currency:
                                'ILS':'symbol':'1.0-0'}} כולל מע''מ</td>
                            <!-- <td>ללא מע"מ</td> -->
                        </tr>
                        <!-- <tr>
                        <td>{{this.sumOfTotalCostsExcludeConstractionExcludeTaxes*1.17 | currency: 'ILS':'symbol':'1.0-0'}}</td>
                        <td>כולל מע"מ</td>
                    </tr> -->
                    </table>
                </div>

                <div class="small-table">
                    <h3> <span>אגרות</span> </h3>
                    <table>
                        <!-- <tr>
                        <td>{{ 300 | currency: 'ILS':'symbol':'1.0-0'}}</td>
                        <td>ללא מע"מ</td>
                    </tr> -->
                        <tr>
                            <td>{{ 300*1.17 | currency: 'ILS':'symbol':'1.0-0' }} כולל מע''מ</td>
                            <!-- <td>כולל מע"מ</td> -->
                        </tr>
                    </table>
                </div>
            </div>

        </div>


        <!-- <button (click)="sendQuotation()">SEND QUOTATION TO SYE</button> -->

        <button *ngIf="calculatedProperties.length > 0 && !showPreview" class="btn" (click)="openPromt()"> תצוגה
            מקדימה</button>
    </div>

    <div id="preview" [class.active]="showPreview">
        <a class="close-section" href="javascript:;" (click)="closePreview()"></a>
        <div id="preview-container">
            <div class="cover-page">
                <!-- <div>{{ user.displayName}}</div> -->
                <div class="logos-holder">
                    <app-gallery [galleryId]="'1'" [section]="projuId+'projlogo'" [autoPlay]="false"
                        [showThumbs]="false" class="logo-img top-project-menu-logo"></app-gallery>

                    <app-gallery [galleryId]="'1'" [section]="compId+'complogo'" [autoPlay]="false" [showThumbs]="false"
                        class="logo-img top-project-menu-logo"></app-gallery>
                </div>
                <!-- <p>Parent Value: {{ formData | json }}</p> -->
                <p>בריטניה ישראל {{this.projTitle}}</p>
                <H1>הצעת מחיר ל{{ formData.firstName }} {{ formData.lastName }}</H1>
                <div class="client-editional-data">
                    <p *ngIf="formData.personalId">
                        <i class="fa fa-id-card"></i> {{ formData.personalId }}
                      </p>
                      <!-- <p *ngIf="formData.firstName || formData.lastName">
                        <i class="fa fa-user"></i> {{ formData.firstName }} {{ formData.lastName }}
                      </p> -->
                      <p *ngIf="formData.mobilePhone">
                        <i class="fa fa-phone"></i> {{ formData.mobilePhone }}
                      </p>
                      <p *ngIf="formData.city">
                        <i class="fa fa-building"></i> {{ formData.city }}
                      </p>
                      <p *ngIf="formData.street">
                         , {{ formData.street }}
                      </p>
                      <p *ngIf="formData.buildingNumber">
                          {{ formData.buildingNumber }}
                      </p>
                      <p *ngIf="formData.email">
                        <i class="fa fa-envelope"></i> {{ formData.email }}
                      </p>
                  </div>
                <div @anim class="current-date">{{ this.date | date:'dd'}}.{{this.date | date:'MM'}}.{{this.date |
                    date:'yy'}}
                </div>
                <app-gallery [galleryId]="'1'" [section]="projuId+'simulation-offer'" [autoPlay]="false"
                    [showThumbs]="false" class="offer-simulation top-project-menu-logo"></app-gallery>
            </div>
        </div>
        <div class="send-offer-button-holder" [class.active]="showPreview">
            <progress max="100" [value]="(percentage | async)">{{ percentage |
                async }} </progress>
            <app-html2pdf [companyId]="'wWuxentPC22HmOo1'" [galleryId]="'wWuxentPC22HmOo'" [section]="'offer'"
                (blob)="saveOffer($event)"></app-html2pdf>
        </div>
    </div>






    <div class="promt" [class.active]="showPromt">
        <div class="promt-holder">
            <h3>להצעת מחיר</h3>
            <div><span>שם: </span>{{ formData.firstName }}</div>
            <div><span>שם משפחה: </span>{{ formData.lastName }}</div>
            <button (click)="openPreview()" mat-stroked-button>להמשיך</button>
            <button (click)="closePromt()" mat-stroked-button>לחזור לעריכה</button>
        </div>
    </div>


    <!-- <button (click)="openPreview()">PREVIEW</button> -->
    <!-- <button class="btn preview-button" [class.active]="showPreview" (click)="openPromt()"> תצוגה מקדימה</button> -->